<template>
    <div style="width:100%">
         <el-select v-model="selectCustomer" filterable remote  :remote-method="remoteMethod" clearable :loading="loading" @change="changeSelected" 
             style="display:block;" :placeholder="$t('msg.fuzzy1WordSearch')" loading-text="loading..." :no-match-text="$t('msg.noDataFound')" :no-data-text="$t('msg.noDataFound')">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
    </div>
</template>

<script>

import { apiFindCustFromSap } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {   
    props: {
         
    },
    data() {
      return {
        loading:false,
        options: [],
        custMap: new Map(),
        selectCustomer:''
      }
    },
    watch:{
      
    },
    mounted() {
    
    },
    methods: {
      changeSelected(select){       
        this.$emit('sync-select-customer-code', this.custMap.get(select));
        this.options = [];

      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          apiFindCustFromSap({ headers: authHeader(), condition:query}).then((response) => {            
            this.options = [];
            this.custMap = new Map();
            var temp = [];
            response.data.forEach((item, index) => {
              var key = item.sapCode + '_' + item.bukrs + '_' + item.bzirk;
              this.custMap.set(key, item);
              temp.push({value: key, label: item.customerNameC+'('+item.sapCode+')' });
            });

            // response.data.forEach( function ( item, index, array)  {               
            // });
            
            this.options = temp; 
            this.loading = false;

          }).catch((err) => {
            console.log(err);
          });
        } else {
          this.options = [];
        }
      }
    }
}
</script>

<style scoped>
   
</style>